import { ClientPortfolioToolIdentificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type { InvestmentToolInput } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentToolSchema";
import { isFundLikeToolType } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentToolType";
import { isValidIsin, normalizeIsin } from "web_myplann/Shared/Utils/isin";

const isIsinIdentification = (tool: InvestmentToolInput) =>
	tool.identificationType === ClientPortfolioToolIdentificationTypeEnum.Isin ||
	(tool.identificationType === null && isValidIsin(tool.identification ?? ""));

const getIsin = (tool: InvestmentToolInput) =>
	isFundLikeToolType(tool.type) &&
	isIsinIdentification(tool) &&
	tool.identification
		? normalizeIsin(tool.identification)
		: null;

export const findDuplicateIsinIndex = (
	tools: InvestmentToolInput[],
	tool: InvestmentToolInput,
	editedIndex: number | null,
) => {
	const isin = getIsin(tool);
	if (!isin) {
		return -1;
	}

	return tools.findIndex(
		(other, index) => index !== editedIndex && getIsin(other) === isin,
	);
};

export const mergeToolInstructions = (
	target: InvestmentToolInput,
	source: InvestmentToolInput,
): InvestmentToolInput => ({
	...target,
	instructions: [
		...target.instructions,
		...source.instructions.map((instruction) => ({ ...instruction, id: null })),
	],
});
